import React, { useEffect, useState, useRef } from "react";
import DepartmentTopbar from "./components/DepartmentTopbar";
import DepertmentSidebar from "./components/DepertmentSidebar";
import SuperAdminSidebar from "./components/SuperAdminSidebar";
import Topbar from "./components/Topbar";
import styles from "../../assets/css/Dashboard.module.css";
import { useNavigate } from "react-router-dom";
import {
  FaDownload,
  FaEdit,
  FaEye,
  FaHistory,
  FaPlus,
  FaSearch,
  FaTimes,
} from "react-icons/fa";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const parseDate = (str) => {
  if (!str) return null;
  const [day, month, year] = str.split("-");
  if (!day || !month || !year) return null;
  let fullYear = year;
  if (year.length === 2) {
    fullYear = "20" + year;
  }
  return new Date(`${fullYear}-${month}-${day}`);
};

const formatDateField = (dateValue) => {
  if (!dateValue || dateValue === "0000-00-00 00:00:00" || dateValue === "0000-00-00") {
    return "";
  }
  
  if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return dateValue;
  }
  
  if (typeof dateValue === 'string' && dateValue.includes(' ')) {
    return dateValue.split(' ')[0];
  }
  
  if (typeof dateValue === 'string' && dateValue.match(/^\d{4}$/)) {
    return dateValue + "-01-01"; 
  }
  
  try {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) {
      return "";
    }
    return date.toISOString().split('T')[0];
  } catch (error) {
    return "";
  }
};

// Helper function to format dates for form inputs (handles year-only dates)
const formatDateForInput = (dateValue) => {
  if (!dateValue || dateValue === "0000-00-00 00:00:00" || dateValue === "0000-00-00") {
    return "";
  }
  
  // Handle year-only dates (e.g., "1981", "2012") - convert to January 1st
  if (typeof dateValue === 'string' && dateValue.match(/^\d{4}$/)) {
    return dateValue + "-01-01";
  }
  
  // Handle full dates
  if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return dateValue;
  }
  
  if (typeof dateValue === 'string' && dateValue.includes(' ')) {
    return dateValue.split(' ')[0];
  }
  
  try {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) {
      return "";
    }
    return date.toISOString().split('T')[0];
  } catch (error) {
    return "";
  }
};

const DetailItem = ({ label, value }) => (
  <div style={{ marginBottom: 12 }}>
    <div style={{ fontWeight: 500, color: "#1976d2", fontSize: "0.97rem" }}>
      {label}
    </div>
    <div
      style={{
        background: "#fff",
        borderRadius: 6,
        padding: "7px 12px",
        fontSize: "1rem",
        color: "#333",
        border: "1px solid #e3e6f0",
        minHeight: 36,
      }}
    >
      {value}
    </div>
  </div>
);

// PDF-style detail row component for modal
const DetailRow = ({ label, value }) => (
  <tr>
    <td
      style={{
        fontWeight: 600,
        color: "#222",
        padding: "8px 16px",
        borderBottom: "1px solid #eee",
        width: "35%",
        background: "#f8f8f8",
      }}
    >
      {label}
    </td>
    <td
      style={{
        color: "#333",
        padding: "8px 16px",
        borderBottom: "1px solid #eee",
        background: "#fff",
      }}
    >
      {value}
    </td>
  </tr>
);

function PWDReportList() {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reportPeriod, setReportPeriod] = useState({ start: "", end: "" });
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const user_name = localStorage.getItem("user_name");
  const user_id = localStorage.getItem("user_id");
  const userType = localStorage.getItem("type");
  const userRole = localStorage.getItem("role");
  const isSuperAdmin = userRole === "Super_Admin";
  const matchesLoggedInUser = (item) => {
    const concernedId =
      item?.name_of_concerned_id ?? item?.name_of_concerned ?? "";
    return String(concernedId) === String(user_id ?? "");
  };
  const filterDataForUser = (data) => {
    if (!Array.isArray(data)) return [];
    // If logged-in user is SAE, show only records created by this SAE
    if (String(userType).trim() === "SAE") {
      return data.filter((item) => matchesLoggedInUser(item));
    }
    // Other roles: show all records
    return data;
  };
  const [formData, setFormData] = useState({
    memo_no: "",
    memo_date: "",
    name_of_works: "",
    boc: null,
    type: user_name,
    alotment: "",
    alotment_amount: "",
    work_order_memo_no: "",
    work_order_date: "",
    engence_agency: "",
    estimet_amount: "",
    less_amount: "",
    above_amount: "",
    final_amount: "",
    date_of_agreement: "",
    duration: "",
    date_of_commencement: "",
    date_of_completion: "",
    word_no: "",
    financial_year: "",
    name_of_concerned_sae: "",
    name_of_concerned: user_id,
    department_date: "",
    department: "",
    departmentbaseuser: "",
    physical_status: "",
    final_payment_amount: "",
    unspent_balance: "",
    remarks: "",
    reason: "",
    final_status: "pending",
    status: "",
  });
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedMemoNo, setSelectedMemoNo] = useState("");
  const [statusFormData, setStatusFormData] = useState({
    date: "",
    department: "",
    type: "",
    final_payment_amount: "",
    unspent_balance: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [processingHistory, setProcessingHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [fundList, setFundList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const tableRef = useRef();
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [actionFormData, setActionFormData] = useState({
    date: new Date().toISOString().slice(0, 10),
    department: "",
    user: "",
  });
  const [actionRow, setActionRow] = useState(null);
  // Add state for unspent balance error
  const [unspentError, setUnspentError] = useState("");
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [detailsRow, setDetailsRow] = useState(null);
  const [selectedAction, setSelectedAction] = useState("forward");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/pwd-list.php`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();

        if (Array.isArray(data)) {
          data.sort((a, b) => {
            const dateA = new Date(a.memo_date);
            const dateB = new Date(b.memo_date);
            return dateB - dateA;
          });
          const scopedData = filterDataForUser(data);
          setTableData(scopedData);
          // Show all data including drafts for all roles
          setFilteredData(scopedData);
        } else {
          console.warn("API returned non-array data:", data);
          setTableData([]);
          setFilteredData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setTableData([]);
        setFilteredData([]);
      }
      setLoading(false);
    };

    const fetchFundList = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/fundlist.php`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (data.success) {
          setFundList(data.funds || []);
        }
      } catch (error) {
        console.error("Error fetching fund list:", error);
      }
    };

    const fetchDepartmentList = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/departmentlist.php`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (data.success) {
          const filteredDepartments = data.departments.filter(
            (dept) => dept.department_name !== userType
          );
          setDepartmentList(filteredDepartments || []);
        }
      } catch (error) {
        console.error("Error fetching department list:", error);
      }
    };

    const fetchUserList = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/userlist.php`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (Array.isArray(data)) {
          setUserList(data || []);
        }
      } catch (error) {
        console.error("Error fetching user list:", error);
      }
    };

    fetchData();
    fetchFundList();
    fetchDepartmentList();
    fetchUserList();
    return () => {
      try {
        if ($.fn.DataTable.isDataTable("#pwdTable")) {
          $("#pwdTable").DataTable().destroy();
        }
      } catch (error) {
        console.warn("Error destroying DataTable in cleanup:", error);
      }
    };
  }, []);

  useEffect(() => {
    if (!loading && filteredData.length > 0) {
      // Add a small delay to prevent race conditions
      setTimeout(() => {
        try {
          // Check if DataTable already exists and destroy it first
          if ($.fn.DataTable.isDataTable("#pwdTable")) {
            $("#pwdTable").DataTable().destroy();
          }
          
          $("#pwdTable").DataTable({
            responsive: true,
            pageLength: 10,
            lengthMenu: [
              [10, 25, 50, -1],
              [10, 25, 50, "All"],
            ],
            order: [[1, "desc"]],
            searching: false,
            language: {
              lengthMenu: "Show _MENU_ entries",
              info: "Showing _START_ to _END_ of _TOTAL_ entries",
              infoEmpty: "Showing 0 to 0 of 0 entries",
              infoFiltered: "(filtered from _MAX_ total entries)",
              paginate: {
                first: "First",
                last: "Last",
                next: "Next",
                previous: "Previous",
              },
            },
          });
        } catch (error) {
          console.warn("Error initializing DataTable:", error);
        }
      }, 100);
    }
    return () => {
      try {
        if ($.fn.DataTable.isDataTable("#pwdTable")) {
          $("#pwdTable").DataTable().destroy();
        }
      } catch (error) {
        console.warn("Error destroying DataTable in cleanup:", error);
      }
    };
  }, [filteredData, loading]);

  const handleFilter = () => {
    if (!startDate || !endDate) return;
    try {
      if ($.fn.DataTable.isDataTable("#pwdTable")) {
        $("#pwdTable").DataTable().destroy();
      }
    } catch (error) {
      console.warn("Error destroying DataTable:", error);
      $("#pwdTable").empty();
    }
    const start = new Date(startDate);
    const end = new Date(endDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    if (!Array.isArray(tableData)) {
      setFilteredData([]);
      setReportPeriod({ start: startDate, end: endDate });
      return;
    }

    const filtered = tableData.filter((item) => {
      let memoDate = null;
      if (item.memo_date) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(item.memo_date)) {
          memoDate = new Date(item.memo_date);
        } else if (/^\d{2}-\d{2}-\d{4}$/.test(item.memo_date)) {
          const [day, month, year] = item.memo_date.split("-");
          memoDate = new Date(`${year}-${month}-${day}`);
        } else if (/^\d{2}-\d{2}-\d{2}$/.test(item.memo_date)) {
          const [day, month, year] = item.memo_date.split("-");
          memoDate = new Date(`20${year}-${month}-${day}`);
        }
      }
      if (!memoDate || isNaN(memoDate)) return false;
      memoDate.setHours(0, 0, 0, 0);
      return memoDate >= start && memoDate <= end;
    });
    setFilteredData(filtered);
    setReportPeriod({ start: startDate, end: endDate });
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    setReportPeriod({ start: "", end: "" });
    // Show all data including drafts for all roles
    if (Array.isArray(tableData)) {
      setFilteredData(tableData);
    } else {
      setFilteredData([]);
    }
    setFormData({
      memo_no: "",
      memo_date: "",
      name_of_works: "",
      boc: null,
      type: user_name,
      alotment: "",
      alotment_amount: "",
      work_order_memo_no: "",
      work_order_date: "",
      engence_agency: "",
      estimet_amount: "",
      less_amount: "",
      above_amount: "",
      final_amount: "",
      date_of_agreement: "",
      duration: "",
      date_of_commencement: "",
      date_of_completion: "",
      word_no: "",
      financial_year: "",
      name_of_concerned_sae: "",
      name_of_concerned: user_id,
      department_date: "",
      department: "",
      departmentbaseuser: "",
      physical_status: "",
      final_payment_amount: "",
      unspent_balance: "",
      remarks: "",
      final_status: "pending",
      status: "",
    });
    setSelectedAction("forward");
  };

  const handleTabFilter = (tab) => {
    setActiveTab(tab);
    // Safely destroy DataTable with error handling
    try {
      if ($.fn.DataTable.isDataTable("#pwdTable")) {
        $("#pwdTable").DataTable().destroy();
      }
    } catch (error) {
      console.warn("Error destroying DataTable:", error);
      // Force clear the table if destroy fails
      $("#pwdTable").empty();
    }

    if (!Array.isArray(tableData)) {
      setFilteredData([]);
      return;
    }

    let filtered = tableData;

    // For "all" tab, show all data including drafts for all roles
    if (tab === "all") {
      filtered = tableData;
    } else if (tab === "pending") {
      filtered = tableData.filter(
        (item) => (item.final_status || "").toLowerCase().trim() === "pending"
      );
    } else if (tab === "complete") {
      filtered = tableData.filter(
        (item) => (item.final_status || "").toLowerCase().trim() === "complete"
      );
    } else if (tab === "revert_forward") {
      filtered = tableData.filter((item) => {
        return (
          String(item.current_status) ===
          String(localStorage.getItem("user_id"))
        );
      });
    } else if (tab === "draft") {
      // Show draft data for all roles
      filtered = tableData.filter((item) => {
        const statusValue =
          item.status !== undefined && item.status !== null
            ? String(item.status).trim()
            : "";
        return statusValue === "0";
      });
    }

    if (searchTerm.trim()) {
      filtered = filtered.filter(
        (item) =>
          (item.memo_no &&
            item.memo_no.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (item.name_of_works &&
            item.name_of_works
              .toLowerCase()
              .includes(searchTerm.toLowerCase())) ||
          (item.work_order_meno &&
            item.work_order_meno
              .toLowerCase()
              .includes(searchTerm.toLowerCase())) ||
          (item.engaged_agency &&
            item.engaged_agency
              .toLowerCase()
              .includes(searchTerm.toLowerCase())) ||
          (item.name_of_concerned_name &&
            item.name_of_concerned_name
              .toLowerCase()
              .includes(searchTerm.toLowerCase())) ||
          (item.send_to_name &&
            item.send_to_name.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }

    setFilteredData(filtered);
  };

  const handleSearch = (searchValue) => {
    setSearchTerm(searchValue);
    // Safely destroy DataTable with error handling
    try {
      if ($.fn.DataTable.isDataTable("#pwdTable")) {
        $("#pwdTable").DataTable().destroy();
      }
    } catch (error) {
      console.warn("Error destroying DataTable:", error);
      // Force clear the table if destroy fails
      $("#pwdTable").empty();
    }

    if (!Array.isArray(tableData)) {
      setFilteredData([]);
      return;
    }

    let filtered = tableData;

    // Apply tab filter first
    if (activeTab === "pending") {
      filtered = tableData.filter(
        (item) => (item.final_status || "").toLowerCase().trim() === "pending"
      );
    } else if (activeTab === "complete") {
      filtered = tableData.filter(
        (item) => (item.final_status || "").toLowerCase().trim() === "complete"
      );
    } else if (activeTab === "revert_forward") {
      filtered = tableData.filter((item) => {
        return (
          String(item.current_status) ===
          String(localStorage.getItem("user_id"))
        );
      });
    } else if (activeTab === "draft") {
      // Show draft data for all roles
      filtered = tableData.filter((item) => {
        const statusValue =
          item.status !== undefined && item.status !== null
            ? String(item.status).trim()
            : "";
        return statusValue === "0";
      });
    }

    // Then apply search filter
    if (searchValue.trim()) {
      filtered = filtered.filter(
        (item) =>
          (item.memo_no &&
            item.memo_no.toLowerCase().includes(searchValue.toLowerCase())) ||
          (item.name_of_works &&
            item.name_of_works
              .toLowerCase()
              .includes(searchValue.toLowerCase())) ||
          (item.work_order_meno &&
            item.work_order_meno
              .toLowerCase()
              .includes(searchValue.toLowerCase())) ||
          (item.engaged_agency &&
            item.engaged_agency
              .toLowerCase()
              .includes(searchValue.toLowerCase())) ||
          (item.name_of_concerned_name &&
            item.name_of_concerned_name
              .toLowerCase()
              .includes(searchValue.toLowerCase())) ||
          (item.send_to_name &&
            item.send_to_name.toLowerCase().includes(searchValue.toLowerCase()))
      );
    }

    setFilteredData(filtered);
  };

  const handleProcessingHistory = async (id, memoNo) => {
    setSelectedMemoNo(memoNo);
    setShowModal(true);
    setHistoryLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/singlepwdhistory.php`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ pwd_id: id }),
        }
      );
      const data = await response.json();
      if (data.success && Array.isArray(data.history)) {
        setProcessingHistory(data.history);
      } else {
        setProcessingHistory([]);
      }
    } catch (error) {
      console.error("Error fetching processing history:", error);
      setProcessingHistory([]);
    }
    setHistoryLoading(false);
  };

  const closeModal = () => {
    setShowModal(false);
    setProcessingHistory([]);
    setSelectedMemoNo("");
  };

  const handleViewDetails = (row) => {
    handleProcessingHistory(row.id, row.memo_no);
  };

  // Add missing modal handlers
  const handleEdit = async (id) => {
    try {
      if (!Array.isArray(filteredData)) {
        console.warn("filteredData is not an array");
        return;
      }

      const rowData = filteredData.find((item) => item.id === id);
      if (rowData) {
        const fund = fundList.find(
          (f) => f.fund_name === rowData.allotment_head_name
        );
        
        const status = String(rowData.status || "").trim();
        setSelectedAction(status === "0" ? "draft" : "forward");
        
        setFormData({
          memo_no: rowData.memo_no || "",
          memo_date: formatDateForInput(rowData.memo_date) || "",
          name_of_works: rowData.name_of_works || "",
          boc: rowData.resolution_copy || null,
          type: rowData.type || "",
          alotment: rowData.allotment_head_id || (fund ? fund.id : ""),
          alotment_amount: rowData.alotment_amount || "",
          work_order_memo_no: rowData.work_order_meno || "",
          work_order_date: formatDateForInput(rowData.work_order_date) || "",
          engence_agency: rowData.engaged_agency || "",
          estimet_amount: rowData.estimet_amount || "",
          less_amount: rowData.lessper || "",
          above_amount: rowData.aboveper || "",
          final_amount: rowData.final_amount || "",
          date_of_agreement: formatDateForInput(rowData.date_of_agreement) || "",
          duration: rowData.duration || "",
          date_of_commencement: formatDateForInput(rowData.dateof_commencement) || "",
          date_of_completion: formatDateForInput(rowData.dateof_completion) || "",
          word_no: rowData.word_no || "",
          financial_year: rowData.financial_year || "",
          name_of_concerned_sae: rowData.name_of_concerned_sae || "",
          name_of_concerned: rowData.name_of_concerned_id || user_id,
          department_date: formatDateForInput(rowData.processing_recieving_date) || "",
          department: rowData.send_to_id || "",
          departmentbaseuser: rowData.receiver_id || "",
          physical_status: rowData.physical_status || "",
          final_payment_amount: rowData.final_payment_amount || "",
          unspent_balance: rowData.unspent_balance || "",
          remarks: rowData.remarks || "",
          final_status: rowData.final_status || "pending",
          status: status,
        });
        setIsEditMode(true);
        setEditingId(id);
        setShowAddModal(true);
      }
    } catch (error) {
      console.error("Error preparing data for edit:", error);
      alert("Error preparing data for edit. Please try again.");
    }
  };

  const handleChangeStatus = (id, memoNo) => {
    const row = filteredData.find((item) => item.id === id);
    setSelectedId(id);
    setSelectedMemoNo(memoNo);
    setShowStatusModal(true);
    setStatusFormData({
      type: (row?.final_status || "").toLowerCase().trim(),
      final_payment_amount: row?.final_payment_amount || "",
      unspent_balance: row?.unspent_balance || "",
    });
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setStatusFormData((prev) => {
      let updated = { ...prev, [name]: value };
      if (name === "final_payment_amount") {
        const row = filteredData.find((item) => item.id === selectedId);
        const finalAmount = parseFloat(row?.final_amount) || 0; // Use final amount for calculation
        const finalPaymentAmount = parseFloat(value) || 0;
        let unspent = finalAmount - finalPaymentAmount;
        if (unspent < 0) unspent = 0;
        updated.unspent_balance =
          unspent === 0 ? "0" : unspent.toFixed(2).replace(/^-/, "");
      }
      return updated;
    });
  };

  const handleStatusSubmit = async (e) => {
    e.preventDefault();
    // Validation: When status is "payment done", final payment amount must be > 0
    const isPaymentDone = (statusFormData?.type || "").toLowerCase().trim() === "payment done";
    const amountNumber = parseFloat(statusFormData?.final_payment_amount) || 0;
    if (isPaymentDone && amountNumber <= 0) {
      toast.error("Final Payment Amount must be greater than 0.00 when status is 'Payment Done'.");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_SUPER_ADMIN_API_URL}SAEchangestatus.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            pwd_id: selectedId,
            final_status: statusFormData.type,
            final_payment_amount: statusFormData.final_payment_amount,
            unspent_balance: statusFormData.unspent_balance,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        // Refresh the data
        const refreshResponse = await fetch(
          `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/pwd-list.php`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const refreshData = await refreshResponse.json();

        if (Array.isArray(refreshData)) {
          refreshData.sort((a, b) => {
            const dateA = new Date(a.memo_date);
            const dateB = new Date(b.memo_date);
            return dateB - dateA;
          });
          const scopedData = filterDataForUser(refreshData);
          setTableData(scopedData);
          // Show all records (including drafts) for all roles on refresh
          setFilteredData(scopedData);
        } else {
          console.warn("API returned non-array data for refresh:", refreshData);
          setTableData([]);
          setFilteredData([]);
        }

        setShowStatusModal(false);
        setStatusFormData({
          type: "",
          final_payment_amount: "",
          unspent_balance: "",
        });
        toast.success("Status updated successfully!");
      } else {
        toast.error(
          (data.message || "Failed to update status.").replace(
            "Insafesecent",
            "Sufficient"
          )
        );
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again.");
    }
  };

  const handleAddNewChange = (e) => {
    const { name, value, type, files } = e.target;
    let updatedFormData = {
      ...formData,
      [name]: type === "file" ? files[0] : value,
    };

    if (name === "department") {
      updatedFormData = {
        ...updatedFormData,
        departmentbaseuser: "",
      };
    }

    if (name === "less_amount" && value) {
      updatedFormData = {
        ...updatedFormData,
        [name]: value,
        above_amount: "",
      };
    } else if (name === "above_amount" && value) {
      updatedFormData = {
        ...updatedFormData,
        [name]: value,
        less_amount: "",
      };
    }

    if (
      name === "estimet_amount" ||
      name === "less_amount" ||
      name === "above_amount"
    ) {
      const currentValue = parseFloat(value) || 0;
      const estimateAmount =
        name === "estimet_amount"
          ? currentValue
          : parseFloat(updatedFormData.estimet_amount) || 0;
      const lessPercentage =
        name === "less_amount"
          ? currentValue
          : parseFloat(updatedFormData.less_amount) || 0;
      const abovePercentage =
        name === "above_amount"
          ? currentValue
          : parseFloat(updatedFormData.above_amount) || 0;
      let finalAmount = estimateAmount;
      if (lessPercentage > 0) {
        finalAmount = estimateAmount - (estimateAmount * lessPercentage) / 100;
      } else if (abovePercentage > 0) {
        finalAmount = estimateAmount + (estimateAmount * abovePercentage) / 100;
      }
      updatedFormData.final_amount = Number.isInteger(finalAmount)
        ? String(finalAmount)
        : finalAmount.toString();
    }

    if (name === "final_payment_amount") {
      const alotmentAmount = parseFloat(updatedFormData.alotment_amount) || 0;
      const finalPaymentAmount = parseFloat(value) || 0;
      let unspent = alotmentAmount - finalPaymentAmount;
      if (unspent < 0) {
        setUnspentError("Final Payment Amount cannot exceed Alotment Amount");
        unspent = 0;
      } else {
        setUnspentError("");
      }
      updatedFormData.unspent_balance =
        unspent === 0 ? "0" : unspent.toFixed(2).replace(/^-/, "");
    }

    setFormData(updatedFormData);
  };

  const getFilteredUsers = () => {
    if (!formData.department) return [];

    return userList.filter(
      (user) => user.department_id === formData.department
    );
  };

  const handleAddNewSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);

    if (unspentError) {
      alert(unspentError);
      return;
    }
    try {
      const formDataToSend = new FormData();
      if (isEditMode) {
        formDataToSend.append("pwd_id", editingId);
      }
      const formatNumber = (val) => {
        if (val === null || val === undefined || val === "") return "";
        const num = Number(val);
        if (isNaN(num)) return val;
        return Number.isInteger(num) ? String(num) : num.toString();
      };
      const formatDate = (val) => {
        if (!val) return "";
        return val.split("T")[0];
      };
      // Map form fields to database column names
      formDataToSend.append("type", formData.type || "");
      formDataToSend.append("memo_no", formData.memo_no || "");
      formDataToSend.append("memo_date", formatDate(formData.memo_date) || "");
      formDataToSend.append("name_of_works", formData.name_of_works || "");
      // Handle file upload for resolution_copy
      if (formData.boc) {
        formDataToSend.append("resolution_copy", formData.boc);
      }
      formDataToSend.append("alotment_head_id", formData.alotment || "");
      formDataToSend.append(
        "alotment_amount",
        formatNumber(formData.alotment_amount)
      );
      formDataToSend.append(
        "work_order_meno",
        formData.work_order_memo_no || ""
      );
      formDataToSend.append(
        "work_order_date",
        formatDate(formData.work_order_date) || ""
      );
      formDataToSend.append("engaged_agency", formData.engence_agency || "");
      formDataToSend.append(
        "estimet_amount",
        formatNumber(formData.estimet_amount)
      );
      formDataToSend.append("lessper", formatNumber(formData.less_amount));
      formDataToSend.append("aboveper", formatNumber(formData.above_amount));
      formDataToSend.append(
        "final_amount",
        formatNumber(formData.final_amount)
      );
      formDataToSend.append(
        "date_of_agreement",
        formatDate(formData.date_of_agreement) || ""
      );
      formDataToSend.append("duration", formData.duration || "");
      formDataToSend.append(
        "dateof_commencement",
        formatDate(formData.date_of_commencement) || ""
      );
      formDataToSend.append(
        "dateof_completion",
        formatDate(formData.date_of_completion) || ""
      );
      formDataToSend.append("word_no", formData.word_no || "");
      formDataToSend.append("financial_year", formData.financial_year || "");
      formDataToSend.append(
        "name_of_concerned",
        formData.name_of_concerned || user_id || ""
      );
      formDataToSend.append(
        "processing_recieving_date",
        formatDate(formData.department_date) || ""
      );
      formDataToSend.append("send_to", formData.department || "");
      formDataToSend.append("user_id", formData.departmentbaseuser || "");
      formDataToSend.append("physical_status", formData.physical_status || "");
      formDataToSend.append(
        "final_payment_amount",
        formatNumber(formData.final_payment_amount)
      );
      formDataToSend.append(
        "unspent_balance",
        formatNumber(formData.unspent_balance)
      );
      formDataToSend.append("reason", formData.reason || "");
      const token = localStorage.getItem("token");
      let url, method = "POST", requestBody, headers;
      if (selectedAction === "draft") {
        // For draft, send FormData with fields except Name of Concerned, Processing / Recieving Date, Send to, User, Physical Status to adddraftdata.php
        const draftFormData = new FormData();
        draftFormData.append("type", formData.type || "");
        draftFormData.append("memo_no", formData.memo_no || "");
        draftFormData.append("memo_date", formatDate(formData.memo_date) || "");
        draftFormData.append("name_of_works", formData.name_of_works || "");
        draftFormData.append("allotment_head_id", formData.alotment || "");
        draftFormData.append("allotment_amount", formatNumber(formData.alotment_amount) || "");
        draftFormData.append("work_order_meno", formData.work_order_memo_no || "");
        draftFormData.append("work_order_date", formatDate(formData.work_order_date) || "");
        draftFormData.append("engaged_agency", formData.engence_agency || "");
        draftFormData.append("estimet_amount", formatNumber(formData.estimet_amount) || "");
        draftFormData.append("lessper", formatNumber(formData.less_amount) || "");
        draftFormData.append("aboveper", formatNumber(formData.above_amount) || "");
        draftFormData.append("final_amount", formatNumber(formData.final_amount) || "");
        draftFormData.append("date_of_agreement", formatDate(formData.date_of_agreement) || "");
        draftFormData.append("duration", formData.duration || "");
        draftFormData.append("dateof_commencement", formatDate(formData.date_of_commencement) || "");
        draftFormData.append("dateof_completion", formatDate(formData.date_of_completion) || "");
        draftFormData.append("word_no", formData.word_no || "");
        draftFormData.append("financial_year", formData.financial_year || "");
        draftFormData.append("final_payment_amount", formatNumber(formData.final_payment_amount) || "");
        draftFormData.append("unspent_balance", formatNumber(formData.unspent_balance) || "");
        draftFormData.append("remarks", formData.remarks || "");
        draftFormData.append("reason", formData.reason || "");
        draftFormData.append("physical_status", formData.physical_status || "");
        // Add name_of_concerned with current user's ID for draft status
        draftFormData.append("name_of_concerned", user_id || "");
        // Set status to 0 for draft
        draftFormData.append("status", "0");
        // Add allotment details
        draftFormData.append("alotment_head_id", formData.alotment || "");
        draftFormData.append("alotment_amount", formatNumber(formData.alotment_amount) || "");
        // Add ID for update operations
        if (isEditMode) {
          draftFormData.append("id", editingId);
        }
        url = isEditMode
          ? `${process.env.REACT_APP_SUPER_ADMIN_API_URL}update_draft_pwd.php`
          : `${process.env.REACT_APP_SUPER_ADMIN_API_URL}add_draft_pwd.php`;
        requestBody = draftFormData;
        headers = {
          Authorization: `Bearer ${token}`,
        };
      } else {
        formDataToSend.append("status", "1");
        url = isEditMode
          ? `${process.env.REACT_APP_SUPER_ADMIN_API_URL}edit-pwd.php`
          : `${process.env.REACT_APP_SUPER_ADMIN_API_URL}add-pwd.php`;
        requestBody = formDataToSend;
        headers = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(url, {
        method: method,
        headers: headers,
        body: requestBody,
      });
      const data = await response.json();
      if (!data.success) {
        toast.error((data.message || "").replace("Insafesecent", "Sufficient"));
      } else {
        try {
          const token = localStorage.getItem("token");
          const refreshResponse = await fetch(
            `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/pwd-list.php`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
          const refreshData = await refreshResponse.json();

          // Sort if array
          if (Array.isArray(refreshData)) {
            refreshData.sort((a, b) => {
              const dateA = new Date(a.memo_date);
              const dateB = new Date(b.memo_date);
              return dateB - dateA;
            });
            const scopedData = filterDataForUser(refreshData);
            setTableData(scopedData);
            // Apply role-based filtering for refresh
            let refreshFilteredData = scopedData;
            if (userType !== "SAE") {
              refreshFilteredData = scopedData.filter((item) => {
                const statusValue =
                  item.status !== undefined && item.status !== null
                    ? String(item.status).trim()
                    : "";
                return statusValue !== "0"; // Exclude draft items (status = "0")
              });
            }
            setFilteredData(refreshFilteredData);
          } else {
            console.warn(
              "API returned non-array data for refresh:",
              refreshData
            );
            setTableData([]);
            setFilteredData([]);
          }

          if ($.fn.DataTable.isDataTable("#pwdTable")) {
            $("#pwdTable").DataTable().destroy();
          }

          setShowAddModal(false);
          setIsEditMode(false);
          setEditingId(null);
          setFormData({
            memo_no: "",
            memo_date: "",
            name_of_works: "",
            boc: null,
            type: "",
            alotment: "",
            alotment_amount: "",
            work_order_memo_no: "",
            work_order_date: "",
            engence_agency: "",
            estimet_amount: "",
            less_amount: "",
            above_amount: "",
            final_amount: "",
            date_of_agreement: "",
            duration: "",
            date_of_commencement: "",
            date_of_completion: "",
            word_no: "",
            financial_year: "",
            name_of_concerned_sae: "",
            name_of_concerned: user_id,
            department_date: "",
            department: "",
            departmentbaseuser: "",
            physical_status: "",
            final_payment_amount: "",
            unspent_balance: "",
            remarks: "",
            reason: "",
            final_status: "pending",
            status: "",
          });
        } catch (refreshError) {
          console.error("Error refreshing data:", refreshError);
        }
      }
      console.log(formData);
    } catch (error) {
      console.error("Error submitting data:", error);
      console.log(error);
    }
  };

  // Add functions to calculate counts for each tab
  const getPendingCount = () => {
    if (!Array.isArray(tableData)) return 0;
    return tableData.filter(
      (item) => (item.final_status || "").toLowerCase().trim() === "pending"
    ).length;
  };

  const getCompleteCount = () => {
    if (!Array.isArray(tableData)) return 0;
    return tableData.filter(
      (item) => (item.final_status || "").toLowerCase().trim() === "complete"
    ).length;
  };

  const getDraftCount = () => {
    if (!Array.isArray(tableData)) return 0;
    return tableData.filter((item) => {
      const statusValue =
        item.status !== undefined && item.status !== null
          ? String(item.status).trim()
          : "";
      return statusValue === "0";
    }).length;
  };

  const getRevertForwardCount = () => {
    if (!Array.isArray(tableData)) return 0;
    return tableData.filter(
      (item) =>
        String(item.current_status) === String(localStorage.getItem("user_id"))
    ).length;
  };

  const getAllCount = () => {
    if (!Array.isArray(tableData)) return 0;
    // All roles: count all items including drafts
    return tableData.length;
  };

  // Add handler functions for Forward and Revert buttons
  const handleForward = (row) => {
    setActionType("forward");
    setActionRow(row);
    setActionFormData({
      date: new Date().toISOString().slice(0, 10),
      department: "",
      user: "",
    });
    setShowActionModal(true);
  };

  const handleRevert = (row) => {
    setActionType("revert");
    setActionRow(row);
    setActionFormData({
      date: new Date().toISOString().slice(0, 10),
      department: "",
      user: "",
    });
    setShowActionModal(true);
  };

  const handleActionFormChange = (e) => {
    const { name, value } = e.target;
    setActionFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "department" ? { user: "" } : {}),
    }));
  };

  const getActionFilteredUsers = () => {
    if (!actionFormData.department) return [];
    return userList.filter(
      (user) => user.department_id === actionFormData.department
    );
  };

  const handleActionSubmit = async (e) => {
    e.preventDefault();
    if (!actionRow || !actionFormData.department || !actionFormData.user) {
      alert("Please select all fields.");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/pwd-forward-revert.php`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            pwd_id: actionRow.id,
            date: actionFormData.date,
            department_id: actionFormData.department,
            user_id: actionFormData.user,
            to_status: actionType,
            by_id: user_id,
          }),
        }
      );
      const data = await response.json();
      if (data.success) {
        // Refresh the table data
        const refreshResponse = await fetch(
          `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/pwd-list.php`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const refreshData = await refreshResponse.json();
        if (Array.isArray(refreshData)) {
          refreshData.sort((a, b) => {
            const dateA = new Date(a.memo_date);
            const dateB = new Date(b.memo_date);
            return dateB - dateA;
          });
        }
        const scopedData = filterDataForUser(refreshData);
        setTableData(scopedData);
        // Apply role-based filtering for refresh
        let refreshFilteredData = scopedData;
        if (userType !== "SAE") {
          refreshFilteredData = scopedData.filter((item) => {
            const statusValue =
              item.status !== undefined && item.status !== null
                ? String(item.status).trim()
                : "";
            return statusValue !== "0"; // Exclude draft items (status = "0")
          });
        }
        setFilteredData(refreshFilteredData);
        setShowActionModal(false);
        toast.success(
          data.message ||
          `${actionType === "forward" ? "Forwarded" : "Reverted"
          } successfully!`
        );
      } else {
        toast.error(
          (data.message || "Failed to update status.").replace(
            "Insafesecent",
            "Sufficient"
          )
        );
      }
    } catch (error) {
      console.error("Error submitting action:", error);
      toast.error("Error submitting action. Please try again.");
    }
  };

  const handleViewDetailsPopup = (row) => {
    setDetailsRow(row);
    setShowDetailsModal(true);
  };

  return (
    <>
      {isSuperAdmin ? <Topbar /> : <DepartmentTopbar />}
      <div className="d-flex">
        {isSuperAdmin ? <SuperAdminSidebar /> : <DepertmentSidebar />}
        <div className={styles.dashboardContainer}>
          <div className="d-flex align-items-center mb-4">
            <h2
              className="mb-0"
              style={{
                color: "#2c3e50",
                fontWeight: "500",
                fontSize: "1.5rem",
              }}
            >
              PWD Reports
            </h2>
          </div>
          <div
            className="card mb-4"
            style={{ borderRadius: "8px", backgroundColor: "#fff" }}
          >
            <div className="card-body p-3">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div className="row g-3 align-items-end flex-grow-1">
                  <div className="col-auto">
                    <label className="form-label small text-muted mb-1">
                      Start Date
                    </label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      style={{ width: "160px", borderColor: "#dee2e6" }}
                    />
                  </div>
                  <div className="col-auto">
                    <label className="form-label small text-muted mb-1">
                      End Date
                    </label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      style={{ width: "160px", borderColor: "#dee2e6" }}
                    />
                  </div>
                  <div className="col-auto">
                    <button
                      className="btn btn-primary btn-sm px-4"
                      onClick={handleFilter}
                      disabled={!startDate || !endDate}
                    >
                      Apply Filter
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm px-3 ms-2"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                  </div>
                </div>
                {/* Show Add New button only for SAE user (not super admin) */}
                {userType === "SAE" &&
                  localStorage.getItem("role") !== "Super_Admin" && (
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => setShowAddModal(true)}
                    >
                      <FaPlus /> Add New
                    </button>
                  )}
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body p-2">
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <ul
                  className="nav nav-tabs mb-0"
                  id="pwdTab"
                  role="tablist"
                  style={{ flex: 1 }}
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === "all" ? "active" : ""
                        }`}
                      type="button"
                      onClick={() => handleTabFilter("all")}
                      style={{
                        border: "none",
                        backgroundColor:
                          activeTab === "all" ? "#007bff" : "transparent",
                        color: activeTab === "all" ? "white" : "#6c757d",
                        padding: "8px 16px",
                        borderRadius: "4px 4px 0 0",
                        marginRight: "4px",
                        fontWeight: activeTab === "all" ? "500" : "400",
                      }}
                    >
                      All ({getAllCount()})
                    </button>
                  </li>
                  {/* Draft tab visible for all roles */}
                  <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === "draft" ? "active" : ""
                          }`}
                        type="button"
                        onClick={() => handleTabFilter("draft")}
                        style={{
                          border: "none",
                          backgroundColor:
                            activeTab === "draft" ? "#007bff" : "transparent",
                          color: activeTab === "draft" ? "white" : "#6c757d",
                          padding: "8px 16px",
                          borderRadius: "4px 4px 0 0",
                          marginRight: "4px",
                          fontWeight: activeTab === "draft" ? "500" : "400",
                        }}
                      >
                        Draft ({getDraftCount()})
                      </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === "revert_forward" ? "active" : ""
                        }`}
                      type="button"
                      onClick={() => handleTabFilter("revert_forward")}
                      style={{
                        border: "none",
                        backgroundColor:
                          activeTab === "revert_forward"
                            ? "#007bff"
                            : "transparent",
                        color:
                          activeTab === "revert_forward" ? "white" : "#6c757d",
                        padding: "8px 16px",
                        borderRadius: "4px 4px 0 0",
                        marginRight: "4px",
                        fontWeight:
                          activeTab === "revert_forward" ? "500" : "400",
                      }}
                    >
                      Revert/Forward ({getRevertForwardCount()})
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === "pending" ? "active" : ""
                        }`}
                      type="button"
                      onClick={() => handleTabFilter("pending")}
                      style={{
                        border: "none",
                        backgroundColor:
                          activeTab === "pending" ? "#007bff" : "transparent",
                        color: activeTab === "pending" ? "white" : "#6c757d",
                        padding: "8px 16px",
                        borderRadius: "4px 4px 0 0",
                        marginRight: "4px",
                        fontWeight: activeTab === "pending" ? "500" : "400",
                      }}
                    >
                      Pending ({getPendingCount()})
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === "complete" ? "active" : ""
                        }`}
                      type="button"
                      onClick={() => handleTabFilter("complete")}
                      style={{
                        border: "none",
                        backgroundColor:
                          activeTab === "complete" ? "#007bff" : "transparent",
                        color: activeTab === "complete" ? "white" : "#6c757d",
                        padding: "8px 16px",
                        borderRadius: "4px 4px 0 0",
                        marginRight: "4px",
                        fontWeight: activeTab === "complete" ? "500" : "400",
                      }}
                    >
                      Complete ({getCompleteCount()})
                    </button>
                  </li>
                </ul>
                <div
                  className="d-flex align-items-center"
                  style={{ minWidth: "300px" }}
                >
                  <div className="input-group input-group-sm">
                    <span
                      className="input-group-text"
                      style={{
                        backgroundColor: "#f8f9fa",
                        borderColor: "#dee2e6",
                      }}
                    >
                      <FaSearch
                        style={{ color: "#6c757d", fontSize: "14px" }}
                      />
                    </span>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search by memo no, works, agency, user..."
                      value={searchTerm}
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{
                        borderColor: "#dee2e6",
                        fontSize: "0.875rem",
                        padding: "0.375rem 0.75rem",
                      }}
                    />
                    {searchTerm && (
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        type="button"
                        onClick={() => handleSearch("")}
                        style={{ borderColor: "#dee2e6" }}
                      >
                        <FaTimes style={{ fontSize: "12px" }} />
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div style={{ width: "100%", overflowX: "auto" }}>
                <table
                  ref={tableRef}
                  id="pwdTable"
                  className="table mb-0"
                  style={{ borderCollapse: "collapse", textAlign: "left" }}
                >
                  <thead>
                    <tr className="bg-light">
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Memo No
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          textAlign: "left",
                        }}
                      >
                        Memo Date
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Name of Works
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        BOC
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Alotment(Head)
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Alotment Amount
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          textAlign: "left",
                        }}
                      >
                        Work Order Memo No
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Work Order Date
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Engaged Agency
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Estimate Amount
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Final Value
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Date of Agreement
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Duration
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Date of Commencement
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Date of Completion
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "120px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Word No
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "150px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Financial Year
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Name of Concerned SAE
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Processing Date
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Department
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Physical Status
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Final Payment Amount
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Unspent Balance
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Remarks
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        {" "}
                        Current Status
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "250px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        {" "}
                        Status
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          maxWidth: "auto",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          textAlign: "left",
                        }}
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td
                          colSpan="25"
                          style={{ textAlign: "center", padding: "2rem" }}
                        >
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : filteredData.length === 0 ? (
                      <tr>
                        <td
                          colSpan="25"
                          style={{
                            textAlign: "center",
                            padding: "2rem",
                            color: "#6c757d",
                            fontSize: "1rem",
                          }}
                        >
                          No data found for the selected date range
                        </td>
                      </tr>
                    ) : (
                      filteredData.map((row, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              width: "120px",
                              minWidth: "120px",
                              maxWidth: "120px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.memo_no}
                          </td>
                          <td
                            style={{
                              width: "120px",
                              minWidth: "120px",
                              maxWidth: "120px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.memo_date}
                          </td>
                          <td
                            style={{
                              width: "220px",
                              minWidth: "220px",
                              maxWidth: "220px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.name_of_works}
                          </td>
                          <td
                            style={{
                              width: "120px",
                              minWidth: "120px",
                              maxWidth: "120px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.resolution_copy ? (
                              <a
                                href={`${process.env.REACT_APP_SUPER_ADMIN_API_URL}/${row.resolution_copy}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-primary"
                              >
                                <FaDownload />
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                          <td
                            style={{
                              width: "150px",
                              minWidth: "150px",
                              maxWidth: "150px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.allotment_head_name}
                          </td>
                          <td
                            style={{
                              width: "160px",
                              minWidth: "160px",
                              maxWidth: "160px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.alotment_amount}
                          </td>
                          <td
                            style={{
                              width: "180px",
                              minWidth: "180px",
                              maxWidth: "180px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.work_order_meno}
                          </td>
                          <td
                            style={{
                              width: "150px",
                              minWidth: "150px",
                              maxWidth: "150px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {formatDateField(row.work_order_date)}
                          </td>
                          <td
                            style={{
                              width: "180px",
                              minWidth: "180px",
                              maxWidth: "180px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.engaged_agency}
                          </td>
                          <td
                            style={{
                              width: "150px",
                              minWidth: "150px",
                              maxWidth: "150px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.estimet_amount}
                          </td>
                          <td
                            style={{
                              width: "150px",
                              minWidth: "150px",
                              maxWidth: "150px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.final_amount}
                          </td>
                          <td
                            style={{
                              width: "140px",
                              minWidth: "140px",
                              maxWidth: "140px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {formatDateField(row.date_of_agreement)}
                          </td>
                          <td
                            style={{
                              width: "120px",
                              minWidth: "120px",
                              maxWidth: "120px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.duration}
                          </td>
                          <td
                            style={{
                              width: "140px",
                              minWidth: "140px",
                              maxWidth: "140px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {formatDateField(row.dateof_commencement)}
                          </td>
                          <td
                            style={{
                              width: "140px",
                              minWidth: "140px",
                              maxWidth: "140px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {formatDateField(row.dateof_completion)}
                          </td>
                          <td
                            style={{
                              width: "120px",
                              minWidth: "120px",
                              maxWidth: "120px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.word_no || ""}
                          </td>
                          <td
                            style={{
                              width: "150px",
                              minWidth: "150px",
                              maxWidth: "150px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.financial_year || ""}
                          </td>
                          <td
                            style={{
                              width: "220px",
                              minWidth: "220px",
                              maxWidth: "220px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.name_of_concerned_name}
                          </td>
                          <td
                            style={{
                              width: "140px",
                              minWidth: "140px",
                              maxWidth: "140px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {formatDateField(row.processing_recieving_date)}
                          </td>
                          <td
                            style={{
                              width: "140px",
                              minWidth: "140px",
                              maxWidth: "140px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.send_to_name}
                          </td>
                          <td
                            style={{
                              width: "140px",
                              minWidth: "140px",
                              maxWidth: "140px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.physical_status}
                          </td>
                          <td
                            style={{
                              width: "140px",
                              minWidth: "140px",
                              maxWidth: "140px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.final_payment_amount}
                          </td>
                          <td
                            style={{
                              width: "140px",
                              minWidth: "140px",
                              maxWidth: "140px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.unspent_balance}
                          </td>
                          <td
                            style={{
                              width: "200px",
                              minWidth: "200px",
                              maxWidth: "200px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.remarks}
                          </td>
                          <td
                            style={{
                              width: "200px",
                              minWidth: "200px",
                              maxWidth: "200px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {row.current_status_user_name && row.current_status_department_name 
                              ? `${row.current_status_user_name} (${row.current_status_department_name})`
                              : row.current_status_user_name || row.current_status_department_name || ''
                            }
                          </td>
                          <td
                            style={{
                              width: "140px",
                              minWidth: "140px",
                              maxWidth: "140px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {(() => {
                              // If status is null or empty, return empty string
                              if (!row.status && !row.final_status) {
                                return <span></span>;
                              }
                              
                              const finalStatus = (row.final_status || "")
                                .toLowerCase()
                                .trim();
                              const statusValue = String(row.status || "").trim();
                              
                              // Show Draft status (highest priority)
                              if (statusValue === "0" && finalStatus === "draft") {
                                return (
                                  <span className="badge bg-secondary">
                                    Draft
                                  </span>
                                );
                              }
                              
                              // Show Complete status (second priority)
                              if (finalStatus === "complete" ) {
                                return (
                                  <span className="badge bg-success">
                                    Complete
                                  </span>
                                );
                              }
                              
                              // Show Pending status (catch-all for other pending cases)
                              if (finalStatus === "pending") {
                                return (
                                  <span className="badge bg-warning text-dark">
                                    Pending
                                  </span>
                                );
                              }
                              
                              if (finalStatus === "work not started") {
                                return (
                                  <span className="badge bg-secondary">
                                    Work Not Started
                                  </span>
                                );
                              }
                              
                              if (finalStatus === "payment done") {
                                return (
                                  <span className="badge bg-info text-dark">
                                    Payment Done
                                  </span>
                                );
                              }
                              
                              return null;
                            })()}
                          </td>
                          <td
                            style={{
                              width:
                                String(row.current_status) ===
                                  String(localStorage.getItem("user_id"))
                                  ? "auto"
                                  : "auto",
                              minWidth:
                                String(row.current_status) ===
                                  String(localStorage.getItem("user_id"))
                                  ? "auto"
                                  : "auto",
                              display: "flex",
                              gap: "6px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "left",
                            }}
                          >
                            {(() => {
                              const finalStatus = (row.final_status || "").toLowerCase().trim();
                              const statusValue = String(row.status || "").trim();
                              
                              // Show limited actions for draft status
                              if (statusValue === "0" && finalStatus === "draft") {
                                return (
                                  <div className="d-flex gap-2">
                                    <button
                                      className="btn btn-secondary btn-sm"
                                      onClick={() => handleViewDetailsPopup(row)}
                                    >
                                      <FaEye /> View
                                    </button>
                                    {userType === "SAE" && finalStatus !== "payment done" && (
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => handleEdit(row.id)}
                                      >
                                        <FaEdit /> 
                                      </button>
                                    )}
                                    {/* History button removed for draft items */}
                                  </div>
                                );
                              }
                              
                              // Show Change Status button only for pending items
                              if (finalStatus === "pending" || (statusValue === "0" && finalStatus !== "draft")) {
                                return (
                                  <div className="d-flex gap-2">
                                    <button
                                      className="btn btn-secondary btn-sm"
                                      onClick={() => handleViewDetailsPopup(row)}
                                    >
                                      <FaEye /> View
                                    </button>
                                    
                                    {String(row.status) === "1" && 
                                     localStorage.getItem("role") !== "Super_Admin" &&
                                     String(row.current_status) === String(user_id) &&
                                     finalStatus !== "payment done" && (
                                        <>
                                          <button
                                            className="btn btn-warning btn-sm"
                                            onClick={() => handleForward(row)}
                                          >
                                            Forward
                                          </button>
                                          <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => handleRevert(row)}
                                          >
                                            Revert
                                          </button>
                                        </>
                                    )}
                                    
                                    {(userType === "SAE" || userType === "AE" || userType === "Accountant") && (
                                      <button
                                        className="btn btn-success btn-sm"
                                        onClick={() => handleChangeStatus(row.id, row.memo_no)}
                                      >
                                        Change Status
                                      </button>
                                    )}
                                    
                                    {userType === "SAE" && finalStatus !== "payment done" && (
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => handleEdit(row.id)}
                                      >
                                        <FaEdit /> 
                                      </button>
                                    )}
                                    <button
                                      className="btn btn-info btn-sm"
                                      onClick={() => handleProcessingHistory(row.id, row.memo_no)}
                                    >
                                      <FaHistory /> 
                                    </button>
                                  </div>
                                );
                              }
                              
                              // Default action buttons for other statuses
                              return (
                                <div className="d-flex gap-2">
                                  <button
                                    className="btn btn-secondary btn-sm"
                                    onClick={() => handleViewDetailsPopup(row)}
                                  >
                                    <FaEye /> View
                                  </button>
                                  
                                  {String(row.status) === "1" && 
                                   localStorage.getItem("role") !== "Super_Admin" &&
                                   String(row.current_status) === String(user_id) &&
                                   finalStatus !== "payment done" && (
                                      <>
                                        <button
                                          className="btn btn-warning btn-sm"
                                          onClick={() => handleForward(row)}
                                        >
                                          Forward
                                        </button>
                                        <button
                                          className="btn btn-danger btn-sm"
                                          onClick={() => handleRevert(row)}
                                        >
                                          Revert
                                        </button>
                                      </>
                                  )}
                                  
                                  {(userType === "SAE" || userType === "AE" || userType === "Accountant") &&
                                    finalStatus !== "payment done" && (
                                      <button
                                        className="btn btn-success btn-sm"
                                        onClick={() => handleChangeStatus(row.id, row.memo_no)}
                                      >
                                        Change Status
                                      </button>
                                  )}
                                  
                                  {userType === "SAE" && finalStatus !== "payment done" && (
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() => handleEdit(row.id)}
                                    >
                                      <FaEdit /> 
                                    </button>
                                  )}
                                  
                                  <button
                                    className="btn btn-info btn-sm"
                                    onClick={() => handleProcessingHistory(row.id, row.memo_no)}
                                  >
                                    <FaHistory /> 
                                  </button>
                                </div>
                              );
                            })()}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <div className="p-3 border-top">
                <p
                  className="mb-0 text-muted"
                  style={{
                    fontSize: "0.875rem",
                    borderLeft: "3px solid #007bff",
                    paddingLeft: "10px",
                  }}
                >
                  <i className="far fa-calendar-alt me-2"></i>
                  Report generated for the period: {reportPeriod.start ||
                    "-"}{" "}
                  to {reportPeriod.end || "-"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Processing History Modal */}
      {showModal && (
        <div
          className="modal fade show "
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div
              className="modal-content p-0"
              style={{
                backgroundColor: "#f8f9fb",
                borderRadius: 12,
                boxShadow: "0 12px 24px rgba(0,0,0,0.12)",
              }}
            >
              {/* Card-style colored header */}
              <div
                style={{
                  backgroundColor: "#1976d2",
                  borderTopLeftRadius: 12,
                  borderTopRightRadius: 12,
                  padding: "18px 32px",
                  borderBottom: "2px solid #1565c0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <h5
                  className="modal-title mb-0"
                  style={{
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: "1.25rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <i
                    className="fas fa-history"
                    style={{
                      marginRight: 10,
                      color: "#fff",
                      fontSize: "1.3rem",
                    }}
                  ></i>
                  Work Order No - {selectedMemoNo}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={closeModal}
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #dee2e6",
                    borderRadius: "50%",
                    width: 22,
                    height: 22,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.2rem",
                    color: "#6c757d",
                  }}
                ></button>
              </div>
              <div
                className="modal-body"
                style={{
                  maxHeight: "calc(100vh - 200px)",
                  overflowY: "auto",
                  background: "#f8f9fb",
                  padding: "32px 24px",
                }}
              >
                {historyLoading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : processingHistory?.length === 0 ? (
                  <div className="text-center py-4 text-muted">
                    No processing history found
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped align-middle">
                      <thead className="table-dark">
                        <tr style={{ textTransform: "capitalize" }}>
                          <th>Department Name</th>
                          <th>Concerned Name</th>
                          <th>Date</th>
                          <th>Type</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {processingHistory
                          .sort((a, b) => {
                            const dateA = new Date(a.creating_date);
                            const dateB = new Date(b.creating_date);
                            return dateA - dateB; // Ascending order (oldest first)
                          })
                          .map((history, index) => {
                            const showToStatus =
                              history.to_status &&
                              history.to_status.trim() !== "";
                            return (
                              <tr
                                key={index}
                                style={{ textTransform: "capitalize" }}
                              >
                                <td>{history.department_name}</td>
                                <td>{history.user_name}</td>
                                <td>{formatDateField(history.creating_date)}</td>
                                <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{history.type}</td>
                                {showToStatus ? (
                                  <td>
                                    <span
                                      style={{
                                        textTransform: "capitalize",
                                        fontSize: "1em",
                                      }}
                                    >
                                      {history.to_status} by{" "}
                                      {history.by_user_name}
                                    </span>
                                  </td>
                                ) : null}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add New Large Modal */}
      {showAddModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ padding: "12px 20px" }}>
                <h5
                  className="modal-title"
                  style={{
                    color: "#2c3e50",
                    fontWeight: 500,
                    fontSize: "1.2rem",
                  }}
                >
                  {isEditMode ? "Edit Document" : "Add New File"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowAddModal(false);
                    setIsEditMode(false);
                    setEditingId(null);
                    setFormData({
                      memo_no: "",
                      memo_date: "",
                      name_of_works: "",
                      boc: null,
                      type: "",
                      alotment: "",
                      alotment_amount: "",
                      work_order_memo_no: "",
                      work_order_date: "",
                      engence_agency: "",
                      estimet_amount: "",
                      less_amount: "",
                      above_amount: "",
                      final_amount: "",
                      date_of_agreement: "",
                      duration: "",
                      date_of_commencement: "",
                      date_of_completion: "",
                      word_no: "",
                      financial_year: "",
                      name_of_concerned_sae: "",
                      name_of_concerned: user_id,
                      department_date: "",
                      department: "",
                      departmentbaseuser: "",
                      physical_status: "",
                      final_payment_amount: "",
                      unspent_balance: "",
                      remarks: "",
                      final_status: "pending",
                      status: "",
                    });
                  }}
                ></button>
              </div>

              <form onSubmit={handleAddNewSubmit}>
                <div
                  className="modal-body"
                  style={{ padding: "18px 20px 10px 20px" }}
                >
                  <div className="container-fluid">
                    <div className="row g-2">
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Type
                        </label>
                        <select
                          className="form-control form-control-sm mb-2"
                          name="type"
                          value={formData.type}
                          onChange={handleAddNewChange}
                          required
                        >
                          <option value="">--Select Type--</option>
                          <option value="NIQ">NIQ</option>
                          <option value="NIEQ">NIEQ</option>
                          <option value="NIT">NIT</option>
                          <option value="NIET">NIET</option>
                          <option value="EIO">EIO</option>
                        </select>
                      </div>
                      <br></br>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Memo No
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="memo_no"
                          value={formData.memo_no}
                          onChange={handleAddNewChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Memo Date
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="memo_date"
                          value={formData.memo_date}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Name of Works
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="name_of_works"
                          value={formData.name_of_works}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Resolution copy of MCIC/BOC/Tender Committee
                        </label>
                        <input
                          type="file"
                          className="form-control form-control-sm mb-2"
                          name="boc"
                          onChange={handleAddNewChange}
                          accept="image/*"
                        />
                        {isEditMode &&
                          formData.boc &&
                          typeof formData.boc === "string" && (
                            <div>
                              Current file:{" "}
                              <a
                                href={`${process.env.REACT_APP_SUPER_ADMIN_API_URL}/${formData.boc}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {formData.boc}
                              </a>
                            </div>
                          )}
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Alotment Fund
                        </label>
                        <select
                          className="form-control form-control-sm mb-2"
                          name="alotment"
                          value={formData.alotment}
                          onChange={handleAddNewChange}
                        >
                          <option value="">--Select Alotment Funds--</option>
                          {fundList.map((fund) => (
                            <option
                              className="text-capitalize"
                              key={fund.id}
                              value={fund.id}
                            >
                              {fund.fund_name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Alotment Amount
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="alotment_amount"
                          value={formData.alotment_amount}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Work Order Memo No
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="work_order_memo_no"
                          value={formData.work_order_memo_no}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Work Order Date
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="work_order_date"
                          value={formData.work_order_date}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Date of Agreement
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="date_of_agreement"
                          value={formData.date_of_agreement}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-4">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Engaged Agency
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="engence_agency"
                          value={formData.engence_agency}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-2">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Estimet Amount
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="estimet_amount"
                          value={formData.estimet_amount}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-2">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Less(%)
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="less_amount"
                          value={formData.less_amount}
                          onChange={handleAddNewChange}
                          disabled={!!formData.above_amount}
                        />
                      </div>
                      <div className="col-md-2">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Above(%)
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="above_amount"
                          value={formData.above_amount}
                          onChange={handleAddNewChange}
                          disabled={!!formData.less_amount}
                        />
                      </div>
                      <div className="col-md-2">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Final Amount
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="final_amount"
                          value={formData.final_amount}
                          onChange={handleAddNewChange}
                          readOnly
                          style={{ backgroundColor: "#f8f9fa" }}
                        />
                      </div>

                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Duration
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="duration"
                          value={formData.duration}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Date of Commencement
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="date_of_commencement"
                          value={formData.date_of_commencement}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Date of Completion
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm mb-2"
                          name="date_of_completion"
                          value={formData.date_of_completion}
                          onChange={handleAddNewChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Word No
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="word_no"
                          value={formData.word_no}
                          onChange={(e) => {
                            // Only allow numbers
                            const value = e.target.value.replace(/\D/g, '');
                            setFormData({
                              ...formData,
                              word_no: value
                            });
                          }}
                          placeholder="Enter word number"
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Financial Year
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm mb-2"
                          name="financial_year"
                          value={formData.financial_year}
                          onChange={handleAddNewChange}
                          placeholder="e.g. 2023-2024"
                        />
                      </div>
                      <div className="col-md-6 d-flex align-items-center gap-3" style={{ marginTop: "32px" }}>
                        <div className="form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="saveAsDraft"
                            name="actionType"
                            value="draft"
                            checked={selectedAction === "draft"}
                            onChange={(e) => setSelectedAction(e.target.value)}
                          />
                          <label className="form-check-label" htmlFor="saveAsDraft" style={{ fontSize: "0.95rem" }}>
                            Save as Draft
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="forwardRevert"
                            name="actionType"
                            value="forward"
                            checked={selectedAction === "forward"}
                            onChange={(e) => setSelectedAction(e.target.value)}
                          />
                          <label className="form-check-label" htmlFor="forwardRevert" style={{ fontSize: "0.95rem" }}>
                            Forward / Revert
                          </label>
                        </div>
                      </div>
                      {selectedAction !== "draft" && (
                        <>
                          <div className="col-md-6">
                            <label
                              className="form-label fw-medium mb-1"
                              style={{ color: "#495057", fontSize: "0.95rem" }}
                            >
                              Name of Concerned
                            </label>
                            <input
                              type="text"
                              value={user_name}
                              name="name_of_concerned_sae"
                              className="form-control form-control-sm mb-2"
                              disabled
                            />
                          </div>
                          <div className="col-md-6">
                            <label
                              className="form-label fw-medium mb-1"
                              style={{ color: "#495057", fontSize: "0.95rem" }}
                            >
                              Processing / Recieving Date
                            </label>
                            <input
                              type="date"
                              className="form-control form-control-sm mb-2"
                              name="department_date"
                              value={formData.department_date}
                              onChange={handleAddNewChange}
                            />
                          </div>
                          <div className="col-md-6">
                            <label
                              className="form-label fw-medium mb-1"
                              style={{ color: "#495057", fontSize: "0.95rem" }}
                            >
                              Send to
                            </label>
                            <select
                              className="form-control form-control-sm mb-2"
                              name="department"
                              value={formData.department}
                              onChange={handleAddNewChange}
                            >
                              <option value="">--Select Department--</option>
                              {departmentList.map((dept) => (
                                <option key={dept.id} value={dept.id}>
                                  {dept.department_name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label
                              className="form-label fw-medium mb-1"
                              style={{ color: "#495057", fontSize: "0.95rem" }}
                            >
                              User
                            </label>
                            <select
                              className="form-control form-control-sm mb-2"
                              name="departmentbaseuser"
                              value={formData.departmentbaseuser}
                              onChange={handleAddNewChange}
                              disabled={!formData.department}
                            >
                              <option value="">
                                {!formData.department
                                  ? "--Select Department First--"
                                  : getFilteredUsers().length === 0
                                    ? "--No Users Available--"
                                    : "--Select User--"}
                              </option>
                              {getFilteredUsers().map((user) => (
                                <option key={user.id} value={user.id}>
                                  {user.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label
                              className="form-label fw-medium mb-1"
                              style={{ color: "#495057", fontSize: "0.95rem" }}
                            >
                              Physical Status
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm mb-2"
                              name="physical_status"
                              value={formData.physical_status}
                              onChange={handleAddNewChange}
                            />
                          </div>
                        </>
                      )}

                      <div className="col-12">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Remarks
                        </label>
                        <textarea
                          className="form-control form-control-sm mb-2"
                          name="remarks"
                          value={formData.remarks}
                          onChange={handleAddNewChange}
                          rows={2}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer" style={{ padding: "10px 20px" }}>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setShowAddModal(false);
                      setIsEditMode(false);
                      setEditingId(null);
                      setFormData({
                        memo_no: "",
                        memo_date: "",
                        name_of_works: "",
                        boc: null,
                        type: "",
                        alotment: "",
                        alotment_amount: "",
                        work_order_memo_no: "",
                        work_order_date: "",
                        engence_agency: "",
                        estimet_amount: "",
                        less_amount: "",
                        above_amount: "",
                        final_amount: "",
                        date_of_agreement: "",
                        duration: "",
                        date_of_commencement: "",
                        date_of_completion: "",
                        word_no: "",
                        financial_year: "",
                        name_of_concerned_sae: "",
                        name_of_concerned: user_id,
                        department_date: "",
                        department: "",
                        departmentbaseuser: "",
                        physical_status: "",
                        final_payment_amount: "",
                        unspent_balance: "",
                        remarks: "",
                        final_status: "pending",
                        status: "",
                      });
                      setSelectedAction("forward");
                    }}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary btn-sm">
                    {isEditMode ? "Update" : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Status Modal */}
      {showStatusModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ padding: "12px 20px" }}>
                <h5
                  className="modal-title"
                  style={{
                    color: "#2c3e50",
                    fontWeight: 500,
                    fontSize: "1.2rem",
                  }}
                >
                  Update Status for Memo No: {selectedMemoNo}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowStatusModal(false);
                    setStatusFormData({
                      type: "",
                      final_payment_amount: "",
                      unspent_balance: "",
                    });
                  }}
                ></button>
              </div>

              <form onSubmit={handleStatusSubmit}>
                <div
                  className="modal-body"
                  style={{ padding: "18px 20px 10px 20px" }}
                >
                  <div className="container-fluid">
                    <div className="row g-2">
                      <div className="col-12">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Status
                        </label>
                        <select
                          className="form-select form-select-sm mb-2"
                          name="type"
                          value={statusFormData.type}
                          onChange={handleStatusChange}
                          required
                        >
                          <option value="">Select Status</option>
                          <option value="complete">Complete</option>
                          <option value="work not started">
                            Work Not Started
                          </option>
                          <option value="payment done">Payment Done</option>
                          <option value="pending">Pending</option>
                        </select>
                      </div>
                      <div className="col-12">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Final Payment Amount
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="final_payment_amount"
                          value={statusFormData.final_payment_amount}
                          onChange={handleStatusChange}
                          required
                        />
                      </div>
                      <div className="col-12">
                        <label
                          className="form-label fw-medium mb-1"
                          style={{ color: "#495057", fontSize: "0.95rem" }}
                        >
                          Unspent Balance
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-sm mb-2"
                          name="unspent_balance"
                          value={statusFormData.unspent_balance}
                          readOnly
                          style={{ backgroundColor: "#f8f9fa" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer" style={{ padding: "10px 20px" }}>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setShowStatusModal(false);
                      setStatusFormData({
                        type: "",
                        final_payment_amount: "",
                        unspent_balance: "",
                      });
                    }}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary btn-sm">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Forward/Revert Action Modal */}
      {showActionModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {actionType === "forward" ? "Forward" : "Revert"} Memo No:{" "}
                  {actionRow?.memo_no}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowActionModal(false)}
                ></button>
              </div>
              <form onSubmit={handleActionSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={actionFormData.date}
                      onChange={handleActionFormChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Department</label>
                    <select
                      className="form-control"
                      name="department"
                      value={actionFormData.department}
                      onChange={handleActionFormChange}
                      required
                    >
                      <option value="">--Select Department--</option>
                      {departmentList.map((dept) => (
                        <option key={dept.id} value={dept.id}>
                          {dept.department_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">User</label>
                    <select
                      className="form-control"
                      name="user"
                      value={actionFormData.user}
                      onChange={handleActionFormChange}
                      required
                      disabled={!actionFormData.department}
                    >
                      <option value="">
                        {!actionFormData.department
                          ? "--Select Department First--"
                          : getActionFilteredUsers().length === 0
                            ? "--No Users Available--"
                            : "--Select User--"}
                      </option>
                      {getActionFilteredUsers().map((user) => (
                        <option key={user.id} value={user.id}>
                          {user.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => setShowActionModal(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary btn-sm">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {showDetailsModal && detailsRow && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div
              className="modal-content"
              style={{
                borderRadius: 0,
                boxShadow: "0 2px 16px rgba(0,0,0,0.12)",
                border: "1px solid #bbb",
                background: "#fff",
                fontFamily: "serif",
              }}
            >
              <div
                className="modal-header"
                style={{
                  borderBottom: "1px solid #bbb",
                  background: "#f8f8f8",
                  padding: "16px 24px",
                }}
              >
                <h4
                  className="modal-title"
                  style={{
                    fontWeight: 700,
                    fontSize: "1.35rem",
                    color: "#222",
                    letterSpacing: 1,
                  }}
                >
                  PWD Report Details
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowDetailsModal(false)}
                ></button>
              </div>
              <div
                className="modal-body"
                style={{
                  padding: "32px 32px 24px 32px",
                  background: "#fff",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "1.05rem",
                  }}
                >
                  <tbody>
                    <DetailRow label="Memo No" value={detailsRow.memo_no} />
                    <DetailRow label="Memo Date" value={detailsRow.memo_date} />
                    <DetailRow
                      label="Name of Works"
                      value={detailsRow.name_of_works}
                    />
                    <DetailRow
                      label="BOC"
                      value={
                        detailsRow.resolution_copy ? (
                          <a
                            href={`${process.env.REACT_APP_SUPER_ADMIN_API_URL}/${detailsRow.resolution_copy}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#1976d2",
                              textDecoration: "underline",
                            }}
                          >
                            Download
                          </a>
                        ) : (
                          "N/A"
                        )
                      }
                    />
                    <DetailRow
                      label="Alotment(Head)"
                      value={detailsRow.allotment_head_name}
                    />
                    <DetailRow
                      label="Alotment Amount"
                      value={detailsRow.alotment_amount}
                    />
                    <DetailRow
                      label="Work Order Memo No"
                      value={detailsRow.work_order_meno}
                    />
                    <DetailRow
                      label="Work Order Date"
                      value={formatDateField(detailsRow.work_order_date)}
                    />
                    <DetailRow
                      label="Engaged Agency"
                      value={detailsRow.engaged_agency}
                    />
                    <DetailRow
                      label="Estimate Amount"
                      value={detailsRow.estimet_amount}
                    />
                    <DetailRow
                      label="Final Value"
                      value={detailsRow.final_amount}
                    />
                    <DetailRow
                      label="Date of Agreement"
                      value={formatDateField(detailsRow.date_of_agreement)}
                    />
                    <DetailRow label="Duration" value={detailsRow.duration} />
                    <DetailRow
                      label="Date of Commencement"
                      value={formatDateField(detailsRow.dateof_commencement)}
                    />
                    <DetailRow
                      label="Date of Completion"
                      value={formatDateField(detailsRow.dateof_completion)}
                    />
                    <DetailRow
                      label="Word No"
                      value={detailsRow.word_no || "N/A"}
                    />
                    <DetailRow
                      label="Financial Year"
                      value={detailsRow.financial_year || "N/A"}
                    />
                    <DetailRow
                      label="Name of Concerned SAE"
                      value={detailsRow.name_of_concerned_name}
                    />
                    <DetailRow
                      label="Processing Date"
                      value={formatDateField(detailsRow.processing_recieving_date)}
                    />
                    <DetailRow
                      label="Department"
                      value={detailsRow.send_to_name}
                    />
                    <DetailRow
                      label="Physical Status"
                      value={detailsRow.physical_status}
                    />
                    <DetailRow
                      label="Final Payment Amount"
                      value={detailsRow.final_payment_amount}
                    />
                    <DetailRow
                      label="Unspent Balance"
                      value={detailsRow.unspent_balance}
                    />
                    <DetailRow label="Remarks" value={detailsRow.remarks} />
                    <DetailRow
                      label="Current Status"
                      value={`${detailsRow.current_status_user_name} (${detailsRow.current_status_department_name})`}
                    />
                    <DetailRow label="Status" value={detailsRow.final_status} />
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
}
export default PWDReportList;
